module.exports = "/assets/site/images/MVM_asztali_tennis.jpg?28d38eecdb46d8d2a68310fa28c1b488";